gameSkipWinsButton = {};

gameSkipWinsButton.create = function () {
  var button = new PIXI.Container();

  InputHelpers.addGenerics(button);
  InputHelpers.addSkipWinPlatformEnabledFlag(button);

  button.canEnable = function () {
    return (
      gameController.canEnableSkip() &&
      !this._flags.modal.active &&
      this._flags.skipWinPlatformEnabled
    );
  };

  button.canShow = function () {
    return (
      gameController.canEnableSkip() &&
      !this._flags.modal.active &&
      this._flags.skipWinPlatformEnabled
    );
  };

  button.onPressedCallback = function () {
    resourceManager.getController("inputOverlord").disableAll();
    // AllWaysPayWinAnimator.skip();
    PayAnywhereWinAnimator.skip();
    gameController.skipWins();
    if (button.soundName !== "") button.playSound();
  };

  return button;
};

gameSkipWinsButton.initialise = function (json, object) {
  object.soundName = json.soundName || "";
};
gameSkipWinsButton.getFilesRequired = function () {
  return [];
};

resourceManager.registerObjectType(
  "gameSkipWinsButton",
  gameSkipWinsButton.create,
  gameSkipWinsButton.initialise,
  gameSkipWinsButton.getFilesRequired
);
